import axios from 'axios';
import actions from '../actions/definitions';

export default {
	namespaced: true,
	state: {
		links: [],
		classes: [],
		events: [],
	},
	mutations: {
		[actions.SET_LINK]: (state, data) => {
			state.links = data.links;
		},
		[actions.SET_CLASSES]: (state, data) => {
			state.classes = data;
		},
		[actions.SET_EVENTS]: (state, data) => {
			state.events = data;
		},
	},
	actions: {
		[actions.GET_DEFINITIONS_LINKS]: async ({ commit, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'definitions_links');

				const response = await axios.get(link.href);

				const { data } = response;

				commit(actions.SET_LINK, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_CLASSES]: async ({ commit }, link) => {
			try {
				const response = await axios.get(link.href);
				const { data } = response;
				commit(actions.SET_CLASSES, data.sort((a, b) => (a.order > b.order ? 1 : -1)));
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_ENDURANCE_EVENTS]: async ({ commit }, link) => {
			try {
				const response = await axios.get(link.href);
				const { data } = response;
				commit(actions.SET_EVENTS, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_EVENTS]: async ({ commit, state }) => {
			try {
				const link = state.links.find(x => x.rel === 'get_all_events');
				const response = await axios.get(link.href);
				const { data } = response;
				commit(actions.SET_EVENTS, data.sort((a, b) => (a.order > b.order ? 1 : -1)));
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_EVENTS_BY_NSHORT]: async ({ commit, state }, nShort) => {
			try {
				const link = state.links.find(x => x.rel === 'get_events_by_class_nshort');
				const href = link.href
					.replace('{classnshort}', nShort);
				const response = await axios.get(href);
				const { data } = response;
				commit(actions.SET_EVENTS, data.sort((a, b) => (a.order > b.order ? 1 : -1)));
			} catch (error) {
				throw error;
			}
		},
		[actions.FETCH_IEVENT_NCLASS_BY_SHORT]: async ({ state }, { iEventCode, nClassCode }) => {
			try {
				const link = state.links.find(x => x.rel === 'get_iEvent_nClass_By_Short' && x.templated);

				const href = link.href
					.replace('{iEventShort}', iEventCode)
					.replace('{nClassShort}', nClassCode);

				const response = await axios.get(href);

				const { data } = response;

				return data;
			} catch (error) {
				throw error;
			}
		},
	},
	getters: {
		DefinitionsLinks: state => state.links,
		Classes: state => state.classes,
		Events: state => state.events,
	},
};
